<template>
  <b-container>
    <h1>Welcome to chezjenn</h1>
    <div class="div2">
      <p>This site will showcase some recipes. </p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Welcome',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.div2 {
  border-radius: 25px;
}
</style>
